import Text from 'components/Text/Text';
import { useLoggedUserRestaurants } from 'hooks/useLoggedUserRestaurants';
import React from 'react';
import style from './PricesScrollableList.module.scss';

interface IPricesScrollableListRestaurant {
	id: string;
	restaurantName: string | null;
	price: number | null;
}

interface IPricesScrollableList {
	restaurants: IPricesScrollableListRestaurant[];
}

const PricesScrollableList: React.FC<IPricesScrollableList> = ({ restaurants }) => {
	const accessibleRestaurants = useLoggedUserRestaurants(restaurants);

	return (
		<div className={style.container}>
			{accessibleRestaurants.length
				? accessibleRestaurants.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={`${el.restaurantName} / ${el.price}`} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default React.memo(PricesScrollableList);
